/* ==========================================================
   feel-calculators.js
   Used on: templates/page.self-checks.json → sections/feel-calculators.liquid
   Source: _mockups/02_CALCULATOR_SOURCE/build.py (JS engine)
   ========================================================== */

(function () {
  'use strict';

  var runner = document.querySelector('[data-calc-runner]');
  if (!runner) return;

  var CALC_DATA = window.CALC_DATA;
  if (!CALC_DATA) return;

  /* Translated JS strings (window.FA_CALC_STRINGS, escaped via | t — no re-esc). */
  var FA = window.FA_CALC_STRINGS || {};
  var QUICK_SHOP = FA.quick_shop || 'Quick shop';

  /* Locale-aware URL helper — prefixes raw CALC_DATA product paths with the
     Markets subfolder root (e.g. /de-de). Mirrors snippets/feel-loc-url.liquid. */
  var LOCALE_ROOT = (window.CALC_LOCALE_ROOT && window.CALC_LOCALE_ROOT !== '/') ? window.CALC_LOCALE_ROOT : '';
  function locUrl(p) {
    if (!p || p === '#' || p.indexOf('://') !== -1 || p.charAt(0) === '#') return p || '#';
    if (p.charAt(0) !== '/') p = '/' + p;
    return LOCALE_ROOT + p;
  }

  /* ---- UI refs ---- */
  var ui = {
    subtitle:       runner.querySelector('[data-calc-subtitle]'),
    title:          runner.querySelector('[data-calc-title]'),
    counter:        runner.querySelector('[data-step-counter]'),
    questionText:   runner.querySelector('[data-question-text]'),
    options:        runner.querySelector('[data-options]'),
    progressBar:    runner.querySelector('[data-progress-bar]'),
    progressFill:   runner.querySelector('[data-progress-fill]'),
    stepQ:          runner.querySelector('[data-step="q"]'),
    stepLoading:    runner.querySelector('[data-step="loading"]'),
    stepResult:     runner.querySelector('[data-step="result"]'),
    resultNum:      runner.querySelector('[data-result-score]'),
    resultLabel:    runner.querySelector('[data-result-label]'),
    resultText:     runner.querySelector('[data-result-text]'),
    resultPName:    runner.querySelector('[data-result-product-name]'),
    resultPLink:    runner.querySelector('[data-result-product-link]'),
    calcAnchor:     runner.querySelector('[data-calc-anchor]'), /* stretched-link overlay */
    productImage:   runner.querySelector('[data-product-image]'),
    productRating:  runner.querySelector('[data-product-rating]'),
    productReviews: runner.querySelector('[data-product-reviews]'),
    productDesc:    runner.querySelector('[data-product-desc]'),
    productPrice:   runner.querySelector('[data-product-price]'),
    productQS:      runner.querySelector('[data-product-quickshop]'),
    ringFill:       runner.querySelector('[data-result-ring-fill]'),
    emailForm:      runner.querySelector('[data-email-form]'),
    emailInput:     runner.querySelector('[data-email-input]'),
    emailThanks:    runner.querySelector('[data-email-thanks]'),
  };

  var RING_CIRC = 502.65; // 2 * PI * 80 (radius of SVG circle)

  var activeCalc = null;
  var qIndex = 0;
  var totalScore = 0;

  /* ---- Open ---- */
  function openCalc(calcId) {
    activeCalc = CALC_DATA.calculators[calcId];
    if (!activeCalc) return;
    qIndex = 0;
    totalScore = 0;

    ui.subtitle.textContent = activeCalc.subtitle;
    ui.title.textContent = activeCalc.intro_h;

    // Reset ring to empty
    if (ui.ringFill) {
      ui.ringFill.style.transition = 'none';
      ui.ringFill.style.strokeDashoffset = RING_CIRC;
    }
    // Reset progress bar
    if (ui.progressFill) {
      ui.progressFill.style.transition = 'none';
      ui.progressFill.style.width = '0%';
      // Force reflow before re-enabling transition
      void ui.progressFill.getBoundingClientRect();
      ui.progressFill.style.transition = 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
    }

    renderQuestion();
    showStep('q');
    runner.setAttribute('data-open', 'true');
    runner.querySelector('.calc-runner-card').scrollTop = 0;
    document.body.style.overflow = 'hidden';
  }

  /* ---- Close ---- */
  function closeCalc() {
    runner.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  }

  /* ---- Show step ---- */
  function showStep(which) {
    ui.stepQ.removeAttribute('data-active');
    ui.stepLoading.removeAttribute('data-active');
    ui.stepResult.removeAttribute('data-active');

    if (which === 'q')       { ui.stepQ.setAttribute('data-active', 'true'); }
    else if (which === 'loading') { ui.stepLoading.setAttribute('data-active', 'true'); }
    else if (which === 'result')  { ui.stepResult.setAttribute('data-active', 'true'); }

    // Hide progress bar on loading + result
    if (ui.progressBar) {
      ui.progressBar.style.display = (which === 'q') ? 'block' : 'none';
    }
    runner.querySelector('.calc-runner-card').scrollTop = 0;
  }

  /* ---- Render question ---- */
  function renderQuestion() {
    var q = activeCalc.questions[qIndex];
    if (!q) return;

    ui.counter.textContent = 'Step ' + (qIndex + 1) + ' of ' + activeCalc.questions.length;
    ui.questionText.textContent = q.q;

    // Progress bar fill
    if (ui.progressFill) {
      var pct = ((qIndex + 1) / activeCalc.questions.length) * 100;
      ui.progressFill.style.width = pct + '%';
    }

    // Build option buttons
    ui.options.innerHTML = '';
    var questionLocked = false;
    q.options.forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'calc-option';
      btn.dataset.value = opt.value;
      btn.textContent = opt.label;
      btn.addEventListener('click', function () {
        if (questionLocked) return;
        questionLocked = true;
        ui.options.querySelectorAll('.calc-option').forEach(function (o) {
          o.setAttribute('aria-selected', 'false');
          o.disabled = true;
        });
        btn.setAttribute('aria-selected', 'true');
        totalScore += parseInt(opt.value, 10);
        setTimeout(advance, 250);
      });
      ui.options.appendChild(btn);
    });

    runner.querySelector('.calc-runner-card').scrollTop = 0;
  }

  /* ---- Advance ---- */
  function advance() {
    qIndex++;
    if (qIndex >= activeCalc.questions.length) {
      showLoading();
    } else {
      renderQuestion();
    }
  }

  /* ---- Loading ---- */
  function showLoading() {
    showStep('loading');
    setTimeout(showResult, 1500);
  }

  /* ---- Result ---- */
  function showResult() {
    // Normalise: status logic — higher score = worse, invert to status (100=healthy)
    var maxPossible = activeCalc.questions.reduce(function (acc, q) {
      return acc + Math.max.apply(null, q.options.map(function (o) { return o.value; }));
    }, 0);
    var normalized = Math.round(100 - (totalScore / maxPossible) * 100);

    // Pick threshold (highest min that normalized reaches)
    var threshold = activeCalc.result_thresholds[0];
    activeCalc.result_thresholds.forEach(function (t) {
      if (normalized >= t.min) threshold = t;
    });

    // Fill score
    ui.resultNum.textContent = normalized;
    ui.resultLabel.textContent = threshold.label;
    ui.resultText.textContent = threshold.text;

    // Fill product card — use Shopify-enriched data from CALC_DATA.shopify_products
    var product = activeCalc.result_product;
    var shopifyData = (CALC_DATA.shopify_products || {})[product.handle] || {};

    ui.resultPName.textContent = product.name;
    ui.resultPLink.href = locUrl(product.url);
    if (ui.calcAnchor) ui.calcAnchor.href = locUrl(product.url); /* keep stretched-link in sync */

    // Rating: prefer live metafield from Shopify data (L9 policy), fallback JSON
    var rating = shopifyData.rating || product.rating || '4.9';
    var reviews = shopifyData.rating_count || product.reviews || '';
    if (ui.productRating)  ui.productRating.textContent = rating;
    if (ui.productReviews) ui.productReviews.textContent = reviews;

    // Description
    if (ui.productDesc) ui.productDesc.textContent = product.short_desc || '';

    // Price: use Shopify clean price (L2 — avoid glc-money HTML injection)
    var price = shopifyData.price_clean || product.price || '24.99';
    if (ui.productPrice) ui.productPrice.textContent = price;

    // Product image: real featured image from Shopify, fallback to card_tone gradient
    if (ui.productImage) {
      ui.productImage.style.setProperty('--card-tone', product.card_tone || '#fbe1e8');
      // Remove old img if any
      var oldImg = ui.productImage.querySelector('img');
      if (oldImg) oldImg.remove();
      var imgUrl = shopifyData.image_url || '';
      if (imgUrl) {
        var img = document.createElement('img');
        img.src = imgUrl;
        img.alt = product.name;
        img.loading = 'lazy';
        ui.productImage.appendChild(img);
      }
    }

    // Reset quick shop button
    if (ui.productQS) {
      ui.productQS.removeAttribute('data-added');
      ui.productQS.disabled = false;
      ui.productQS.innerHTML = '<span>+</span> ' + QUICK_SHOP;
      // Store variant ID for cart add
      ui.productQS.dataset.variantId = shopifyData.variant_id || '';
      ui.productQS.dataset.productHandle = product.handle;
    }

    // Reset email form
    if (ui.emailForm) {
      ui.emailForm.removeAttribute('data-hide');
      if (ui.emailInput) ui.emailInput.value = '';
      if (ui.emailThanks) ui.emailThanks.removeAttribute('data-show');
    }

    showStep('result');

    // Animate ring fill
    if (ui.ringFill) {
      ui.ringFill.style.transition = 'none';
      ui.ringFill.style.strokeDashoffset = RING_CIRC;
      void ui.ringFill.getBoundingClientRect();
      ui.ringFill.style.transition = 'stroke-dashoffset 1s cubic-bezier(0.4, 0, 0.2, 1)';
      requestAnimationFrame(function () {
        ui.ringFill.style.strokeDashoffset = RING_CIRC * (1 - normalized / 100);
      });
    }
  }

  /* ---- Restart ---- */
  function restart() {
    if (activeCalc) openCalc(activeCalc.id);
  }

  /* ---- Cart add (Quick shop) ---- */
  function quickShop(btn) {
    if (!activeCalc) return;
    var variantId = btn.dataset.variantId;
    var productHandle = btn.dataset.productHandle;
    var productName = activeCalc.result_product.name;

    if (!variantId) {
      // No variant ID — go to product page
      window.location.href = locUrl(activeCalc.result_product.url);
      return;
    }

    btn.disabled = true;
    btn.innerHTML = '<span class="calc-spinner"></span> ' + (FA.adding || 'Adding…');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        btn.disabled = false;
        btn.setAttribute('data-added', 'true');
        btn.innerHTML = '<span>&#10003;</span> ' + (FA.added || 'Added');
        showToast((FA.added_toast || 'Added to cart — {name}').replace('{name}', productName.split(' — ')[0]));

        // Update cart count badges
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (b) {
              b.textContent = cart.item_count;
            });
          });

        // Close modal, then open cart drawer
        setTimeout(closeCalc, 600);
        setTimeout(openCartDrawer, 900);
      })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = '<span>+</span> ' + QUICK_SHOP;
        window.location.href = locUrl(activeCalc.result_product.url);
      });
  }

  function openCartDrawer() {
    // Try feel:cart:open event first (our theme.liquid handler)
    var opened = false;
    try {
      document.dispatchEvent(new CustomEvent('feel:cart:open'));
      opened = true;
    } catch (e) {}
    if (opened) return;

    // Fallback: data-cd-drawer direct
    var cdDrawer = document.querySelector('[data-cd-drawer]');
    var cdBackdrop = document.querySelector('[data-cd-backdrop]');
    if (cdDrawer) {
      cdDrawer.setAttribute('data-open', 'true');
      cdDrawer.setAttribute('aria-hidden', 'false');
      if (cdBackdrop) cdBackdrop.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
    }
  }

  function showToast(msg) {
    var toast = document.querySelector('[data-calc-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'calc-toast';
      toast.setAttribute('data-calc-toast', '');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<span>&#10003;</span> ' + msg;
    toast.setAttribute('data-show', 'true');
    setTimeout(function () { toast.removeAttribute('data-show'); }, 2400);
  }

  /* ---- Wire events ---- */

  // Open buttons (hub cards)
  document.querySelectorAll('[data-calc-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openCalc(btn.dataset.calcOpen);
    });
  });

  // Close button
  var closeBtn = runner.querySelector('[data-calc-close]');
  if (closeBtn) closeBtn.addEventListener('click', closeCalc);

  // Backdrop click → close
  runner.addEventListener('click', function (e) {
    if (e.target === runner) closeCalc();
  });

  // Restart
  var restartBtn = runner.querySelector('[data-calc-restart]');
  if (restartBtn) restartBtn.addEventListener('click', restart);

  // Quick shop delegation — stopPropagation prevents feel-card-anchor navigation
  if (ui.productQS) {
    ui.productQS.addEventListener('click', function (e) {
      e.stopPropagation();
      quickShop(ui.productQS);
    });
  }

  // Email capture — Shopify newsletter form
  if (ui.emailForm) {
    ui.emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = ui.emailInput && ui.emailInput.value.trim();
      if (!email) return;
      // POST to Shopify customer newsletter endpoint
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: 'form_type=customer&contact[email]=' + encodeURIComponent(email) + '&contact[accepts_marketing]=true&contact[tags]=newsletter,calculator,' + (activeCalc ? activeCalc.id : '')
      }).catch(function () {});
      ui.emailForm.setAttribute('data-hide', 'true');
      if (ui.emailThanks) ui.emailThanks.setAttribute('data-show', 'true');
    });
  }

  // ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && runner.getAttribute('data-open') === 'true') {
      closeCalc();
    }
  });

  // Focus trap (L7 — keep focus inside modal when open)
  runner.addEventListener('keydown', function (e) {
    if (runner.getAttribute('data-open') !== 'true') return;
    if (e.key !== 'Tab') return;
    var focusable = runner.querySelectorAll('button:not([disabled]), input, [tabindex="0"]');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

})();
